module.exports = __webpack_public_path__ + "img/16d004-17.c0e6a76e.png";